import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const StyledSwitch = Styled.div`
    display: flex;
	flex-direction: column;
	position: relative;
	.switch-container {
		height: 26px;
		border: 2px solid transparent;
		border-radius: 13px;
		background-color: #dbdbdb;
		position: relative;
		display: inline-block;
		cursor: pointer;
		-webkit-transition: 0.2s;
		transition: 0.2s;
		outline: none;
		display: flex;
		flex-direction: column;
	}
	.locked-switch {
		opacity: 0.5;
	}

	.toggled-on {
		background-color:#6e0fea;
	}

	.switch-box {
		display: none;
	}

	.switch-slider {
		position: absolute;
		cursor: pointer;
		top: 50%;
		transform: translateY(-50%);
		left: 3px;
		right: 0;
		bottom: 0;

		height: 20px;
		width: 20px;

		background-color: #ffffff;
		border-radius: 26px;

		-webkit-transition: 0.2s;
		transition: 0.2s;
	}

	.toggled-on .switch-slider {
		left: 80%;
		transform: translate(-60%, -50%);
	}

	.switch-container:focus .switch-slider {
		background-color: #a9a9a9;
	}
`;

export const Switch = ({checked, onChange, locked, id, onBlur, cy}) => {
	const handleOnChange = e => {
		e.stopPropagation();
		if (onChange) {
			onChange(checked);
		}
	};

	const keyPressHandler = e => {
		e.preventDefault();
		if (e.key === 'Enter' || e.key === ' ') handleOnChange(e);
	};

	return (
		<StyledSwitch>
			<label
				style={{height: 18, width: 30}}
				className={(checked ? 'switch-container toggled-on' : 'switch-container') + (locked ? ' locked-switch' : '')}
				tabIndex={0}
				onKeyPress={e => keyPressHandler(e)}
				onBlur={onBlur}
			>
				<input
					data-cy={'switch-slider' + (cy ? '-' + cy : '')}
					style={{height: 18}}
					type="checkbox"
					className="switch-box"
					disabled={locked}
					onChange={e => handleOnChange(e)}
					checked={checked}
					id={id}
				/>
				<span style={{height: 18 * (3 / 5), width: 18 * (3 / 5)}} className="switch-slider"></span>
			</label>
		</StyledSwitch>
	);
};

Switch.propTypes = {
	onChange: PropTypes.func,
	checked: PropTypes.bool.isRequired,
	locked: PropTypes.bool,
	id: PropTypes.string,
	onBlur: PropTypes.func,
	cy: PropTypes.string,
};

Switch.defaultProps = {
	checked: false,
};
